// Copying over from /components/Common/KeyMessageTiles
// Props are taken from Contentful and thus is not reusable

import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import KeyMessageTile from './KeyMessageTile'

const Root = styled.div`
  width: 100%;
  display: grid;
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
  grid-gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    grid-auto-rows: auto;
  }
`

export interface KeyMessage {
  icon: string;
  title: string;
  text: string;
}

interface Props {
  items: Array<KeyMessage>;
  hash?: string;
}

function KeyMessages({ items, hash }: Props) {
  return (
    <Root key={hash} id={hash}>
      {items.map(item => (
        <KeyMessageTile
          key={item.title}
          title={item.title}
          text={item.text}
          icon={item.icon}
        />
      ))}
    </Root>
  )
}

export default KeyMessages
